/**
 * iOSのSafariでのbfcache（Back-forward cache）を無効化する。
 *
 * 参考:
 * - https://qiita.com/kyaido/items/5cf9482146b945a4bf67
 * - https://web.dev/bfcache/
 */
export function fixBfcacheProblem() {
    window.addEventListener('pageshow', function (event) {
        if (event.persisted) {
            window.location.reload();
        }
    });
}
